import ProfileHeader from './profile_header'
import { connect } from 'react-redux'
import { getCampaignSelector } from 'redux/selectors/campaign'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    backgroundImage: campaign.background_image,
    backgroundPan: campaign.background_pan,
    gradientColor: campaign.gradient_color,
    preview: campaign.preview,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileHeader)
